    import React, { useMemo } from 'react';
    import { questions } from '../data/questions';

    function QuestionScreen({ currentIdx, onAnswer }) {
    // 현재 인덱스(currentIdx)에 해당하는 질문 객체를 가져옵니다.
    const currentQuestion = questions[currentIdx];
    
    // 선택지 순서를 확실하게 랜덤으로 섞습니다.
    // 질문이 바뀔 때(currentIdx 변경 시)만 새로 실행됩니다.
        const shuffledOptions = useMemo(() => {
            const options = [...currentQuestion.options];
            for (let i = options.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [options[i], options[j]] = [options[j], options[i]];
            }
            return options;
        }, [currentIdx]); // eslint-disable-line react-hooks/exhaustive-deps
    // 전체 질문 개수 중 현재 어디쯤 왔는지 백분율(%)로 계산합니다.
    const progress = (currentIdx / questions.length) * 100;

    return (
        <div className="screen-container question-screen">
        {/* 진행바: 상단에서 사용자의 진행 상태를 시각적으로 보여줍니다. */}
        <div className="progress-bar">
            {/* 계산된 progress 값을 width(너비)로 적용하여 바를 채웁니다. */}
            <div className="progress-fill" style={{ width: `${progress}%` }}></div>
        </div>

        {/* 현재 질문 번호 (인덱스는 0부터 시작하므로 +1을 해줍니다) */}
        <span className="question-number">Q{currentIdx + 1}.</span>
        
        {/* 현재 질문의 제목(텍스트) */}
        <h2 className="question-text">{currentQuestion.question}</h2>
        
        <div className="options-container">
            {/* 확실하게 섞인 선택지 배열(shuffledOptions)을 순회하며 버튼을 생성합니다. */}
            {shuffledOptions.map((option, index) => (
            <button 
                key={`${currentIdx}-${index}`} // 질문마다 고유한 키를 주어 리액트가 변화를 감지하게 합니다.
                className="option-btn" 
                // 클릭 시 부모(App.js)로부터 받은 onAnswer 함수에 선택지 타입(A/B)을 전달합니다.
                onClick={() => onAnswer(option.type)}
            >
                {option.text}
            </button>
            ))}
        </div>
        </div>
    );
    }

    export default QuestionScreen;